import styled from "styled-components";

export const IconSocial = styled.div`
@media (max-width:500px){
    display: none;
}
margin-top: 10px;
display: flex;
justify-content: space-between;
max-width: 65px;
`;


export const IconSocialMobile = styled.div`
@media (min-width:550px){
    display: none;
}

display: flex;
justify-content: space-between;

`;